import React, { useState } from "react";

const DropArea = ({ onDrop, showStatus }) => {
  const [showDrop, setShowDrop] = useState(false);

  return (
    <div
      onDragEnter={() => setShowDrop(true)}
      onDragLeave={() => setShowDrop(false)}
      className={`${showDrop || showStatus ? "drop_area" : "hide_drop"}`}
      onDrop={() => {
        onDrop();
        setShowDrop(false);
      }}
      onDragOver={(e) => e?.preventDefault()}
    >
      Drop Here
    </div>
  );
};

export default DropArea;
